/* ============
 * Members Page
 * ============
 *
 * This is the page for members.
 */
import Vue from 'vue';
import Moment from 'moment';

export default {
  data: () => ({ 
    loading: true,
    organization_products: [],
    member: null,
    timeslot_gap: '00:10',

    addProduct: false,
    new_product_id: null,
    deleteMemberProduct: false,
    product_delete_id: '',

    deleteMember: false,

    addTimeVisible: false,
    day: '',
    start_time: '',
    end_time: '',

    selected_product: null,

    days: [
      'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
    ]
  }),
  
  computed: {
    acceptStatus() {
      var status = '';
      if (this.member.is_accepted) {
        status = 'ACTIVE';
      } else {
        status = 'PENDING';
      }
      return status;
    }
  },

  mounted() {
    Vue.$http.get('/organization_members/'+this.$route.params.id).then(data => {
      this.member = data.data.organization_member;
      this.organization_products = data.data.organization_products;
      this.timeslot_gap = '00:' + data.data.organization.organization_settings.timeslot_gap;
      this.loading = false;
    });

  },

  methods: {
    confirmDeleteMemberProduct() {
      if (this.product_delete_id) {
        var index = this.member.organization_member_products.findIndex(x => x.id === this.product_delete_id);
        if (index > -1) {
          this.selected_product = null;
          this.member.organization_member_products.splice(index, 1);
          this.deleteMemberProduct = false;

          Vue.$http.delete('organization_member_products/' + this.product_delete_id).then(data => {
            this.product_delete_id = '';
            this.$message({
              message: 'Product has been deleted',
              type: 'success',
            });
          });
        }
      }
    },

    confirmDeleteMember() {
      Vue.$http.delete('organization_members/' + this.member.id).then(data => {
        this.$router.push('/members');
      });
    },

    setDay(day) {
      this.day = day;
    },

    removeHour(id) {
      Vue.$http.delete('organization_member_product_businesshours/' + id).then(data => {
        this.selected_product.business_hours.splice(this.selected_product.business_hours.findIndex(x => x.id == id), 1);
      });
    },

    confirmAddTime() {
      if (this.start_time && this.end_time) {
        Vue.$http.post('organization_member_product_businesshours', {
          'organization_member_product_id': this.selected_product.id,
          'day': this.day,
          'start_time': this.start_time,
          'end_time': this.end_time,
        }).then(data => {
          this.selected_product.business_hours.push(data.data);
        });
        this.addTimeVisible = false;
        this.start_time = this.end_time = '';
      }
    },

    showAddHour(index) {
      this.addTimeVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput[index].$refs.reference.focus();
      });
    },

    getHours(product, day) {
      return product.business_hours.filter(x => x.day == day);
    },

    selectProduct(product) {
      this.day = '';
      this.selected_product = product;
    },

    addNewProduct() {
      if (this.new_product_id) {
        if (this.member.organization_member_products.findIndex(x => x.product_id == this.new_product_id) > -1) {
          this.$message({
            message: 'Product already exists',
            type: 'error',
          });
        } else {
          this.addProduct = false;
          Vue.$http.post('/organization_member_products', { 
            organization_member_id: this.member.id, 
            product_id: this.new_product_id 
          }).then(data => {
            this.member.organization_member_products.push(data.data);
          });
        }
      }
    },

    updateColor(color) {
      this.$message({
        message: 'Color updated successfully',
        type: 'success',
      });
      this.update().then(data => {
        this.member.color = data.color;
      });
    },

    async update() {
      return Vue.$http.put('/organization_members/'+this.$route.params.id, this.member).then(data => {
        this.loading = false;
        return data.data;
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/members/show/show.js